import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  ViewChild
} from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { PaymentDetailsService } from 'src/app/modules/pos/quotes/services/payment-details.service';
import { AddressService } from 'core/address/address.service';
import { AppInfoService } from 'core/app-info/app-info.service';
import {
  countriesWithProvince, countryCodeValues, countriesWithoutProvinceOrStateInput,
  regionDropDownCountries, countriesWithPostalCodeField, countriesWithHiddenSTateOrProvinceField
} from 'core/app-info/country-specifics.enum';
import { UtilsService } from 'core/utils/utils.service';
import { AppStateService } from 'core/app-state/app-state.service';
import { EmailPattern } from 'core/common-entities/email-pattern.class';
import { DialogData } from 'core/dialog/dialog-data.class';
import { DialogService } from 'core/dialog/dialog.service';
import { NotificationType } from 'core/notification/notification-config.class';
import { NotificationService } from 'core/notification/notification.service';
import { SearchService } from 'core/search/search.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { PhoneInfo } from 'src/app/modules/shared/entities/phone-info.class';
import { ContactData } from 'src/app/modules/shared/entities/contact-data.class';
import { CanComponentDeactivate } from 'core/unsaved-changes/unsaved-changes-guard.class';
import { ContactsService } from '../services/contacts.service';
import { Contact } from '../entities/contact.class';
import { AccountsDetailService } from '../../accounts/services/accounts-detail.service';

@Component({
  selector: 'app-contacts-dashboard',
  templateUrl: './contacts-dashboard.component.html',
  styleUrls: ['./contacts-dashboard.component.scss'],
  standalone: false
})
export class ContactsDashboardComponent implements OnInit, OnDestroy, CanComponentDeactivate {
  constructor(
    private fb: FormBuilder,
    private contactsService: ContactsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService,
    private appInfoService: AppInfoService,
    private dialogService: DialogService,
    private utilsService: UtilsService,
    private cdRef: ChangeDetectorRef,
    public sanitizer: DomSanitizer,
    private appStateService: AppStateService,
    public addressService: AddressService,
    public searchService: SearchService,
    public paymentDetailsService: PaymentDetailsService,
    public deviceService: DeviceDetectorService,
    private accountsDetailService: AccountsDetailService,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    @Optional() private dialogRef: MatDialogRef<ContactsDashboardComponent>
  ) { }

  @ViewChild('photoFileInput') photoFileInput: ElementRef;
  @Input() addressSource: FormGroup;
  @ViewChild('firstName') firstNameInput: ElementRef;
  @Input() canEdit: boolean;
  @Input() customerCountryId: number;
  @Input() accountName: string;
  @Input() bpNumber: string;

  private subscription = new Subscription();

  form: FormGroup;
  displayedColumns: string[] = ['date', 'detail', 'id', 'isDeleted'];
  notesTableData: any = [];
  deletedNotesData: any[] = [];
  appStrings: AppLocalization;
  isQuoteTemplate: boolean;
  templateValues: PhoneInfo;
  countryList: any;
  displayCountryList = [];
  stateList: any = {};
  displayStateList = [];
  countyList: any = {};
  regionList: any = {};
  displayRegionList = [];
  displayCountyList = [];
  templateValuesContactDetails: any;
  defaultPhotoUrl: string;
  photoUrl;
  photoData = null;
  photoId = null;
  isEditMode = false;
  contactsListRoute: any[];
  phonesControls: AbstractControl[];
  firstPhoneControl: FormGroup;
  isLeadPanel;
  contactsOpened = false;
  dateTimeFormat = this.appInfoService.dateTimeFormat;
  maxPhotoSize = 5242880;
  isLoading = false;
  isOnline: boolean;
  isMobile: boolean;
  maxLengthsInputs = {
    firstName: 25,
    lastName: 25,
    middleName: 25,
    suffix: 30,
    department: 30,
    title: 30,
    addressLine1: 30,
    addressLine2: 30,
    city: 30,
    zipCode: 10,
    note: 2000,
    phoneNumber: 30
  };
  zipControl: AbstractControl;
  contacts_zipOrPostalCode;
  shouldNotDisplayPhoto = this.data?.createContactDialog;
  phoneTest = this.data?.phoneNumberFromQuote;
  firstTimeForPhoneFromQuote = true;
  countryWithCounty = false;
  hasRegion: boolean;
  countryIdFormValue;
  filteredCounties = [];
  countyListPerRegion = [];
  countyListDisplayPerRegion = [];
  addressFormControls;
  countryWithoutStateField = false;
  countryWithHiddenStateProvince = false;

  notesList = new Subject();
  contactId: string;
  customerId: string;
  leadId: string;

  email = new FormControl(
    '',
    Validators.compose([
      Validators.required,
      Validators.pattern(EmailPattern.pattern),
      Validators.maxLength(100)
    ]));

  phoneTypes: number[] = [];
  displayPhoneTypes: { value: number, label: any }[];
  private hotKeyListener = $event => this.checkHotKeys($event as KeyboardEvent);

  dialogOpen$ = new EventEmitter<boolean>();
  dialogButtons: any;
  dialogTitle: string;
  dialogText: any;
  title: string;
  breadcrumbs: any[] = [];

  ngOnInit() {
    this.isOnline = this.appStateService.state.isOnline;
    this.isMobile = this.deviceService.isMobile();
    this.appStrings = this.appInfoService.appStrings;

    if (this.router.url.includes('/quotes/') || this.data?.createContactDialog) {
      this.isQuoteTemplate = true;
    }

    this.initForm();

    this.addressFormControls = (this.form.controls.address as FormGroup).controls;
    this.isLeadPanel = !!this.addressSource; // switch to bool
    this.customerId = this.data?.customerIdDialog || this.activatedRoute.snapshot.params['customerId'];
    this.leadId = this.data?.leadIdDialog || this.activatedRoute.snapshot.params['leadId'];
    this.contactId = this.activatedRoute.snapshot.params['contactId'] || this.activatedRoute.snapshot.params['entityId'];
    this.contactsListRoute = this.customerId ? ['/accounts', this.customerId, { tab: 'contacts' }] :
      ['/accounts-leads', this.leadId, { tab: 'contacts' }];
    this.isEditMode = this.data?.createContactDialog ? false : (this.contactId !== 'new' && !this.isLeadPanel);
    this.title = this.isEditMode ? this.appStrings.contacts_editContact : this.appStrings.contacts_newContact;
    this.breadcrumbs = this.getBreadcrumbs();
    this.fetchAccountDetails();
    const photoUrls = this.contactsService.displayDefaultContactPhoto();
    this.defaultPhotoUrl = photoUrls.defaultPhotoUrl;
    this.photoUrl = photoUrls.photoUrl;
    this.determineZipOrPostalCode();
    this.contactsService.getTemplateValues(
      ([phoneValues, countryValues, stateValues, regionValues, countyValues]) =>
        this.handleTemplateValues(phoneValues, countryValues, stateValues, regionValues, countyValues)
    );

    window.document.addEventListener('keydown', this.hotKeyListener);

    if (this.addressSource) {
      this.subscription.add(this.form.controls.address.valueChanges.subscribe(() => {
        this.form.controls.addressToggleCheckbox.setValue(false, { emitEvent: false });
      }));

      if (this.form.controls.addressToggleCheckbox.value) {
        this.form.controls.address.setValue(this.addressSource.value, { emitEvent: false });
      }

      this.subscription.add(this.addressSource.valueChanges.subscribe(() => {
        if (this.form.controls.addressToggleCheckbox.value) {
          this.form.controls.address.setValue(this.addressSource.value, { emitEvent: false });
        }
      }
      ));
      this.subscription.add(this.addressSource.controls.countryId.valueChanges.subscribe(() => {
        if (this.form.controls.addressToggleCheckbox.value) {
          const newCountryId = this.addressSource.controls.countryId.value;
          this.stateCountyFieldsCheck(newCountryId);
        }
      }));
    }
  }

  stateCountyFieldsCheck(selectedCountryId) {
    if (selectedCountryId) {
      this.countryWithCounty = regionDropDownCountries.indexOf(this.addressService.getCountryValueById(selectedCountryId)) !== -1;
      this.countryWithoutStateField = countriesWithoutProvinceOrStateInput.indexOf(
        this.addressService.getCountryValueById(selectedCountryId)) !== -1;
      this.countryWithHiddenStateProvince = countriesWithHiddenSTateOrProvinceField.indexOf(
        this.addressService.getCountryValueById(selectedCountryId)) !== -1;
    }
  }

  handleTemplateValues(phoneValues, countryValues, stateValues, regionValues, countyValues) {
    this.templateValues = phoneValues;
    this.phoneTypes = Object.keys(this.templateValues.PhoneType).map(phoneType => parseInt(phoneType, 10));
    this.displayPhoneTypes = this.utilsService.mapNumberKeyValueOptions(this.templateValues.PhoneType);
    this.countryList = countryValues.Countries;
    this.displayCountryList = this.utilsService.mapObjectToSelect(this.countryList, 'Key', 'Value');
    this.stateList = this.addressService.getStateListPerCountry(stateValues);
    this.displayStateList = this.utilsService.mapObjectToSelectMultipleList(this.stateList, 'stateId', 'stateName');
    this.regionList = this.addressService.getRegionListPerCountry(regionValues, this.countryList);
    this.countyList = this.addressService.getCountyListPerRegion(countyValues);

    if (this.isEditMode) {
      // Load Contact Details
      this.contactsService.getContactData(this.contactId, (result: ContactData) => this.setValues(result));
    } else {
      this.addPhoneNumber();
      this.setValidationForLead();
      this.selectDefaultCountry();
    }
  }

  setOpened() {
    this.contactsOpened = true;
  }

  setClosed() {
    this.contactsOpened = false;
  }

  private initForm() {
    this.form = this.fb.group({
      id: [this.appInfoService.emptyGuid],
      firstName: [
        this.data?.contactFirstName || '',
        [Validators.required, Validators.maxLength(25)]
      ],
      middleName: [this.data?.contactMiddleName || '', Validators.maxLength(25)],
      lastName: [
        this.data?.contactLastName || '',
        [Validators.required, Validators.maxLength(25)]
      ],
      suffix: ['', Validators.maxLength(30)],
      department: ['', Validators.maxLength(30)],
      title: ['', Validators.maxLength(30)],
      address: this.fb.group({
        id: [this.appInfoService.emptyGuid],
        addressline1: ['', Validators.maxLength(30)],
        addressline2: ['', Validators.maxLength(30)],
        city: ['', Validators.maxLength(30)],
        zip: ['', Validators.maxLength(10)],
        countryId: 0,
        stateId: null,
        countyId: null,
        regionId: null,
        province: this.fb.group({
          name: '',
          id: this.appInfoService.emptyGuid
        })
      }),
      phones: this.fb.array([]),
      email: [
        this.data?.contactEmailFromQuote || '',
        [
          Validators.email,
          Validators.pattern(EmailPattern.pattern),
          Validators.maxLength(100)
        ]],
      addressToggleCheckbox: [false],
      notes: ['', Validators.maxLength(2000)]
    });

    this.phonesControls = (this.form.controls.phones as FormArray).controls;
    this.zipControl = (this.form.controls.address as FormGroup).controls.zip;
  }

  toggle(element) {
    element.visible = !element.visible;
  }

  /**
   * Sets values after contact details
   * @param values - The values from backend
   */
  private setValues(values: ContactData) {
    // set notes
    this.notesTableData = values.notes || [];

    delete values.notes;

    // set photo
    if (values.photo) {
      this.photoId = values.photo.id;
      this.showPhoto(values.photo.id);
    }
    delete values.photo;

    values.phones.forEach(() => this.addPhoneNumber());

    if (!values.address) {
      values.address = {
        id: this.appInfoService.emptyGuid,
        addressline1: '',
        addressline2: '',
        city: '',
        zip: '',
        countryId: 0,
        stateId: null,
        countyId: null,
        regionId: null,
        province: {
          name: '',
          id: this.appInfoService.emptyGuid
        }
      };
      this.selectDefaultCountry();
    }

    // set form values
    values.addressToggleCheckbox = values.addressToggleCheckbox || null;
    values.notes = values.notes || '';
    this.form.patchValue(values);
    this.addressService.countryChanged(values.address.countryId, this.form);
    this.countryIdFormValue = this.addressFormControls.countryId.value;
    this.countryWithCounty = regionDropDownCountries.indexOf(this.addressService.getCountryValueById(this.countryIdFormValue)) !== -1;

    if (this.countryWithCounty && this.countryIdFormValue) {
      this.displayRegionList = this.utilsService.mapObjectToSelect(this.regionList[this.countryIdFormValue], 'regionId', 'regionName');

      if (this.addressFormControls.regionId?.value) {
        this.filteredCounties = this.countyList[this.addressFormControls.regionId.value];
        this.countyListPerRegion = this.countyList[this.addressFormControls.regionId.value];
        this.displayCountyList = this.utilsService.mapObjectToSelect(this.filteredCounties, 'id', 'countyName');
      } else {
        this.countyListPerRegion = this.countyList;
      }
    }

    if (!values.phones.length) {
      this.addPhoneNumber();
    }
  }

  private setValidationForLead() {
    this.firstPhoneControl = (this.phonesControls[0] as FormGroup);
    if (this.isLeadPanel) {
      this.form.controls.email.addValidators([Validators.required]);
      this.form.controls.email.updateValueAndValidity();
      this.firstPhoneControl.controls.phoneNumber.addValidators([Validators.required]);
    }
  }

  private fetchAccountDetails() {
    if (!this.isLeadPanel && (this.customerId || this.leadId)) {
      if (this.customerId) {
        this.accountsDetailService.getAccountDetailsByCustomer(this.customerId).subscribe({
          next: (result) => {
            this.accountName = result.name1 || '';
            this.bpNumber = result.businessPartnerNo || '';
          }
        });
      } else if (this.leadId) {
        this.accountsDetailService.getAccountDetailsByLead(this.leadId).subscribe({
          next: (result) => {
            this.accountName = result.name1 || '';
            this.bpNumber = result.businessPartnerNo || '';
          }
        });
      }
    }
  }

  getBreadcrumbs(): any[] {
    const baseRoute = this.customerId ? '/accounts' : '/accounts-leads';
    const accountId = this.customerId || this.leadId;

    return [
      {
        label: this.appStrings.contacts_accountDetails,
        icon: this.isMobile ? 'arrow_back' : null,
        url: [baseRoute, accountId, { tab: 'contacts' }]
      },
      {
        label: this.title
      }
    ];
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    window.document.removeEventListener('keydown', this.hotKeyListener);
  }

  validateFormIfNotEmpty() {
    // if the form is not empty, set it to touched and return form.valid.
    let valid = true;
    let formChanged = false;
    let formField;
    // something changed from the default values
    if (this.form.dirty) {
      Object.keys(this.form.controls).forEach(
        controlKey => {
          formField = this.form.controls[controlKey];
          if (formField.dirty && formField.value !== '') {
            formChanged = true;
          }
        }
      );
      if (this.firstPhoneControl?.controls.phoneNumber.dirty
        && this.firstPhoneControl?.controls.phoneNumber.value !== '') {
        formChanged = true;
      }
      // if anything changed, we should mark <all> fields
      if (formChanged) {
        Object.keys(this.form.controls).forEach(
          controlKey => {
            formField = this.form.controls[controlKey];
            formField.markAsTouched();
          }
        );
        this.firstPhoneControl?.controls.phoneNumber.markAsTouched();
        valid = this.form.valid;
      }
    }
    return valid;
  }

  addNote() {
    const note = this.form.controls.notes.value;
    if (note?.length) {
      const model = {
        date: new Date(),
        detail: note,
        id: this.appInfoService.emptyGuid,
        isDeleted: false
      };
      this.notesTableData = [model, ...this.notesTableData];
      this.form.controls.notes.reset();
    }
  }

  showPhoto(photoId: string) {
    this.contactsService.getPhoto(photoId).subscribe((data: ArrayBuffer) => {
      const photoBlob = new Blob([new Uint8Array(data, 0, data.byteLength)]);
      this.photoUrl = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(photoBlob));
    });
  }

  deleteNote(index) {
    const dialogParams: DialogData = {
      title: 'Delete note',
      content: 'Are you sure you want to delete this note?',
      buttons: [
        { label: 'Yes', style: 'primary' },
        { label: 'Cancel', focused: true },
      ]
    };

    const dialogRef = this.dialogService.openDialog(dialogParams);
    dialogRef.afterClosed().subscribe(result => {
      // first button pressed
      if (result === 0) {
        this.notesTableData[index].isDeleted = true;
        this.deletedNotesData.push(this.notesTableData.splice(index, 1));
        this.notesTableData = this.notesTableData.slice(0);
      }
    });

  }

  createPhoneNumber() {
    if (this.data && this.firstTimeForPhoneFromQuote) {
      this.firstTimeForPhoneFromQuote = false;
      return this.fb.group({
        id: [this.appInfoService.emptyGuid],
        phoneNumber: [this.data.phoneNumberFromQuote],
        phoneType: [1],
        isEdited: false,
        isDeleted: false
      });
    }

    return this.fb.group({
      id: [this.appInfoService.emptyGuid],
      phoneNumber: [''],
      phoneType: [1],
      isEdited: false,
      isDeleted: false
    });
  }

  addPhoneNumber() {
    (this.form.controls.phones as FormArray).push(this.createPhoneNumber());
  }

  saveChanges() {
    if (!this.isFormValid() || !this.isPhotoSizeValid()) {
      return;
    }

    this.isLoading = true;
    if (this.data?.createContactDialog) {
      // Create new contact from quote/touchpoint page and close the dialog
      this.contactsService.createContact(
        this.customerId,
        this.leadId,
        this.form.value as Contact,
        this.form.controls.phones.value,
        this.notesTableData,
        [],
        this.data?.createContactDialog,
        () => this.callbackAfterContactCreated(),
      );
    } else {
      this.contactsService.createContact(
        this.customerId,
        this.leadId,
        this.form.value as Contact,
        this.form.controls.phones.value,
        this.notesTableData,
        this.photoFileInput.nativeElement.files,
        this.data?.createContactDialog,
        () => this.callbackAfterContactCreated()
      );
    }
  }

  private callbackAfterContactCreated() {
    if (this.data?.createContactDialog) {
      this.dialogRef.close(1);
    } else {
      this.isLoading = false;
      this.form.markAsPristine();
      this.router.navigate(this.contactsListRoute);
    }
  }

  saveChangesAndNew() {
    if (!this.isFormValid() || !this.isPhotoSizeValid()) {
      return;
    }

    this.isLoading = true;

    this.contactsService.createContact(
      this.customerId,
      this.leadId,
      this.form.value as Contact,
      this.form.controls.phones.value,
      this.notesTableData,
      this.photoFileInput.nativeElement.files,
      false,
      () => {
        this.isLoading = false;
        this.notificationService.showNotification(this.appStrings.contacts_createdSuccessfully, NotificationType.Success);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (this.firstNameInput?.nativeElement) {
          this.firstNameInput.nativeElement.focus();
        }
        setTimeout(() => {
          this.initForm();
          this.notesTableData = [];
          this.addPhoneNumber();
          this.deletePhoto(false);
          this.selectDefaultCountry();
        });
      }
    );
  }

  editSaveChanges() {
    if (!this.isFormValid() || !this.isPhotoSizeValid()) {
      return;
    }

    this.isLoading = true;

    this.contactsService.editContact(
      this.customerId,
      this.leadId,
      this.form.value as Contact,
      this.form.controls.phones.value,
      this.notesTableData.concat(...this.deletedNotesData),
      this.photoFileInput.nativeElement.files,
      () => this.callbackAfterContactCreated()
    );
  }

  /**
   * Checks if form is valid
   */
  isFormValid() {
    this.markFormTouched();
    this.form.updateValueAndValidity();

    if (this.form.invalid) {
      this.notificationService.showNotification(this.appStrings.contacts_requiredFields, NotificationType.Error);
      return false;
    }

    return true;
  }

  isPhotoSizeValid() {
    if (this.data?.createContactDialog) {
      return true;
    }

    const photoFile = this.photoFileInput.nativeElement.files[0];
    if (photoFile && (photoFile.size > this.maxPhotoSize)) {
      this.notificationService.showNotification(this.appStrings.contacts_sizeError, NotificationType.Error);
      return false;
    }
    return true;
  }

  checkPhoneNumberValidity(phoneControl: FormGroup) {
    if (phoneControl.value.phoneNumber) {
      phoneControl.controls.phoneType.setValidators([Validators.required]);
    } else {
      phoneControl.controls.phoneType.setValidators(null);
    }
    phoneControl.controls.isEdited.setValue(true);
    phoneControl.controls.phoneType.updateValueAndValidity();
  }

  togglePhoneType(phoneControl: FormGroup) {
    phoneControl.controls.isEdited.setValue(true);
  }

  checkHotKeys($event: KeyboardEvent) {
    if (($event.key === 's' && $event.ctrlKey) && !this.isLeadPanel) {
      $event.preventDefault();
      if ($event.altKey && !this.isEditMode) {
        this.saveChangesAndNew();
      } else {
        if (this.isEditMode) {
          this.editSaveChanges();
        } else {
          this.saveChanges();
        }
      }
    }
  }

  triggerPreviewPhoto() {
    this.photoFileInput.nativeElement.click();
  }

  previewPhoto($event) {
    const files = $event.target.files;
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) === null) {
      this.notificationService.showNotification(this.appStrings.contacts_invalidPhoto, NotificationType.Error);
      this.deletePhoto(false);
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(files[0] as Blob);
    reader.onload = () => this.photoUrl = reader.result as string;
  }

  deletePhoto(purge = true) {
    this.photoFileInput.nativeElement.value = null;
    this.photoUrl = this.defaultPhotoUrl;
    if (purge && this.contactId && this.contactId !== 'new') {
      this.contactsService.purgePhoto(this.contactId)
        .subscribe(result => this.photoId = result);
    }
  }

  addressToggle() {
    if (this.form.controls.addressToggleCheckbox.value) {
      this.addressService.countryChanged(this.addressSource.value.countryId, this.form);
      this.form.controls.address.setValue(this.addressSource.value, { emitEvent: true });
      this.form.controls.addressToggleCheckbox.setValue(true);
    } else {
      this.form.controls.address.reset();
      const emptyAddress = {
        id: this.appInfoService.emptyGuid,
        addressline1: '',
        addressline2: '',
        city: '',
        zip: '',
        countryId: 1,
        stateId: 0,
        countyId: null,
        regionId: null,
        province: {
          name: '',
          id: this.appInfoService.emptyGuid
        }
      };
      this.form.controls.address.setValue(emptyAddress);
    }
    const newCountryId = this.form.controls.addressToggleCheckbox.value ? this.addressSource.value.countryId : 1;
    this.stateCountyFieldsCheck(newCountryId);
  }

  /**
   * Marks the form as touched
   */
  private markFormTouched() {
    Object.keys(this.form.controls).forEach(controlKey => this.form.controls[controlKey].markAsTouched());
  }

  deletePhoneNumber(index: number) {
    const phoneControl = this.phonesControls[index] as FormGroup;
    if (phoneControl.value.id === this.appInfoService.emptyGuid) {
      // if it's not saved yet, delete it
      this.form.controls.phones.value.splice(index, 1);
      this.phonesControls.splice(index, 1);

      const phoneCopy = this.form.controls.phones.value;
      this.form.controls.phones.reset();
      if (phoneCopy.length !== 0) {
        this.form.controls.phones.setValue(phoneCopy);
      } else {
        this.addPhoneNumber();
      }
    } else {
      // if it has been saved, set isDeleted
      phoneControl.controls.isDeleted.setValue(true);
    }
  }

  deleteContact() {
    const dialogParams: DialogData = {
      title: this.appStrings.contacts_deleteContactTitle,
      content: this.appStrings.contacts_deleteContactText,
      buttons: [
        { label: 'Yes', style: 'primary' },
        { label: 'Cancel', focused: true },
      ]
    };

    const dialogRef = this.dialogService.openDialog(dialogParams);
    dialogRef.afterClosed().subscribe(result => {
      // first button pressed
      if (result === 0) {
        this.contactsService.deleteContact(this.contactId,
          () => {
            this.form.markAsPristine();
            this.router.navigate(this.contactsListRoute);
          });
      }
    });
  }

  /**
   * Opens unsaved changes confirmation dialog when creating/editing contact info
   */
  confirmCancel() {
    // Check if contact form has been modified
    if (!this.form.dirty) {
      if (!this.data?.createContactDialog) {
        this.router.navigate(this.contactsListRoute);
        return;
      } else {
        // Closes the add contact pop-up accessed from quote - payment details
        this.dialogRef.close();
        return;
      }
    }

    const confirmLeave = () => {
      if (this.data?.createContactDialog) {
        this.dialogRef.close();
      } else {
        this.form.markAsPristine();
        this.router.navigate(this.contactsListRoute);
      }
    };

    this.dialogTitle = this.appStrings.unsavedChangesTitle;
    this.dialogText = this.appStrings.unsavedChangesConfirm;
    this.dialogButtons = [
      { label: 'Yes', type: 'primary', onclick: confirmLeave.bind(this) },
      { label: 'No', type: 'secondary' },
    ];

    this.cdRef.detectChanges();
    this.dialogOpen$.emit(true);
  }

  selectDefaultCountry() {
    const countryCode = this.appInfoService.userData.UserInfo.CountryCode;
    let countryId = this.customerCountryId || this.addressService.getCountryIdByValue(countryCodeValues[countryCode]);

    if (countryCode !== 'US' && countryCode !== 'CA') {
      if (this.data?.customerIdDialog || this.data?.leadIdDialog) {
        const countryIdFromQuote = this.data.customerDetails.soldToCountry;
        (this.form.controls.address as FormGroup).controls.countryId.setValue(countryIdFromQuote);
        this.addressService.countryChanged(countryIdFromQuote, this.form);
      } else {
        (this.form.controls.address as FormGroup).controls.countryId.setValue(countryId);
        this.addressService.countryChanged(countryId, this.form);
      }
    } else {
      countryId = this.addressService.getCountryIdByValue(countryCodeValues[countryCode]);
      (this.form.controls.address as FormGroup).controls.countryId.setValue(countryId);
      this.addressService.countryChanged(countryId, this.form);
    }

    this.countryIdFormValue = this.addressFormControls.countryId.value;
    this.countryWithCounty = regionDropDownCountries.indexOf(this.addressService.getCountryValueById(this.countryIdFormValue)) !== -1;
    this.countryWithoutStateField = countriesWithoutProvinceOrStateInput.indexOf(
      this.addressService.getCountryValueById(countryId)) !== -1;
    this.countryWithHiddenStateProvince = countriesWithHiddenSTateOrProvinceField.indexOf(
      this.addressService.getCountryValueById(countryId)) !== -1;
  }

  // Whenever the country changes, we update the dependencies of country, region and county fields
  countryChangedEvent(countryId) {
    this.addressService.countryChanged(countryId, this.form);
    this.countryWithCounty = regionDropDownCountries.indexOf(this.addressService.getCountryValueById(countryId)) !== -1;
    this.countryWithoutStateField = countriesWithoutProvinceOrStateInput.indexOf(
      this.addressService.getCountryValueById(countryId)) !== -1;
    this.countryWithHiddenStateProvince = countriesWithHiddenSTateOrProvinceField.indexOf(
      this.addressService.getCountryValueById(countryId)) !== -1;
    this.displayRegionList = this.utilsService.mapObjectToSelect(this.regionList[countryId], 'regionId', 'regionName');
    this.addressFormControls.regionId.reset();
    this.addressFormControls.countyId.reset();
  }

  // Whenever the region changes, we update the county list and reset the value
  regionChangedEvent(regionValue) {
    this.filteredCounties = this.countyList[regionValue];
    this.countyListPerRegion = this.countyList[regionValue];
    this.displayCountyList = this.utilsService.mapObjectToSelect(this.filteredCounties, 'id', 'countyName');
    this.addressFormControls.countyId.reset();
  }

  determineZipOrPostalCode() {
    if (countriesWithProvince && countriesWithPostalCodeField[this.appInfoService.userData.UserInfo.CountryCode]) {
      this.contacts_zipOrPostalCode = this.appStrings.contacts_postalCode;
    } else {
      this.contacts_zipOrPostalCode = this.appStrings.contacts_zip;
    }
  }

  /**
   * Filter Counties
   * @param searchValue - The search value
   */
  filterCounties(searchValue?: string) {
    if (!searchValue) {
      this.filteredCounties = this.countyListPerRegion;
      this.addressFormControls.countyId.markAsUntouched();
      return;
    }

    this.filteredCounties = this.searchService.filterResults(
      searchValue, this.countyListPerRegion, ['countyName'], ['countyName']);
  }

  checkSelectedCounty(eventValue) {
    if (eventValue && !this.addressFormControls.countyId.value?.regionId) {
      this.addressFormControls.countyId.setErrors({ invalidValue: true });
    }
  }


  selectedCounty(event: MatAutocompleteSelectedEvent) {
    const newCounty = event.option.value;
    if (!newCounty) {
      this.filteredCounties = this.countyListPerRegion;
    }
  }

  displayCounty(countyObject) {
    return countyObject?.countyName;
  }

  canDeactivate(): boolean {
    // Allow navigation if form is not dirty or if we're in quote template mode
    if (this.isQuoteTemplate || !this.form) {
      return true;
    }
    return !this.form.dirty;
  }
}
